import { useNavigate } from "react-router-dom"
export const SiteCards = ({ data, siteId, studyId }) => {
    const navigate = useNavigate();
    if (!siteId) {
        return (
            <div className="site-cards-container">
                {data.sites.map((s) => (
                    <div key={s?.siteId}
                        className="site-card"
                        onClick={() => {
                            navigate(
                                `/study/${studyId}/${encodeURIComponent(s?.siteId)}`
                            )
                        }
                        }
                    >
                        <div className="site-top">
                            <div className="site-info">
                                <div className="site-avatar">
                                    {s.siteName?.charAt(0) || "S"}
                                </div>
                                <div className="site-text">
                                    <p className="site-name" style={{ width: "100px" }}>
                                        {s.siteName || "Site"}
                                    </p>
                                    <p className="site-users">
                                        {s.users.length || 0} Total Users
                                    </p>
                                </div>
                            </div>

                            <div className="site-kpi">
                                <div className="kpi-section">
                                    <div className="kpi-pill">
                                        <strong>
                                            {s.users.filter((u) => u.status =="active").length -  s.users.filter(
                                                    (u) =>
                                                        Number(u.status) === 1 ||
                                                        Number(u.is_archived) === 1
                                                ).length}
                                        </strong>{" "}
                                        Active Users
                                    </div>

                                    <div className="kpi-pill">
                                        <strong>
                                            {
                                                s.users.filter(
                                                    (u) =>
                                                        Number(u.is_test) === 1 ||
                                                        Number(u.is_archived) === 1
                                                ).length
                                            }
                                        </strong>{" "}
                                        Excluded
                                    </div>
                                </div>

                                {/* Site-level navigation */}
                                <div
                                    className="toggle-users"
                                    onClick={() =>
                                        navigate(
                                            `/study/${studyId}/${encodeURIComponent(s.siteId)}`
                                        )
                                    }
                                >
                                    View More
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

}